import { RouterProvider } from "react-router";
import { router } from "./routes";
import { AdminDataProvider } from "./components/admin/AdminDataContext";
import { AdminAuthProvider } from "./components/admin/AdminAuthContext";
import { LanguageProvider } from "./components/LanguageContext";
import { ErrorBoundary } from "./components/ErrorBoundary";

export default function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <AdminDataProvider>
          <AdminAuthProvider>
            <RouterProvider router={router} />
          </AdminAuthProvider>
        </AdminDataProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}